// components/suiro/SuiroExtractTable.jsx
import { Grid2 as Grid, Table, TableBody, TableContainer, Paper } from '@mui/material';
import { PowerplantPatrolStep01 } from '../workflow_step';
import { useSuiroHandlers } from '../../hooks/use_suiro_handlers';

export const SuiroExtractTable = ({
  uuid,
  type, // 'optional' or 'required'
  title,
  resetRef,
  notReportRef,
  nameRef,
  tableRef,
  lefts,
  headerHeight,
  suiroExtractList,
  setSuiroExtractList,
  setOtherSuiroExtractList,
  users,
  partners,
  toggleColumn,
  HeaderComponent,
  CommonRowComponent,
  DataRowComponent
}) => {
  const handlers = useSuiroHandlers(suiroExtractList, setSuiroExtractList, toggleColumn);

  return (
    <>
      <Grid size={12}>
        <PowerplantPatrolStep01 title={title} />
      </Grid>

      <Grid size={12}>
        <TableContainer
          ref={tableRef}
          component={Paper}
          sx={{
            overflowX: "auto",
            overflowY: "auto",
            position: 'relative',
            maxHeight: 1000
          }}
        >
          <Table
            stickyHeader
            sx={{
              tableLayout: "auto",
              minWidth: 'max-content',
              '& tbody .MuiTableCell-root': {
                borderBottom: '1px solid rgba(224,224,224,1)'
              },
              '& tbody td:nth-of-type(1), & tbody td:nth-of-type(2), & tbody td:nth-of-type(3)': {
                borderBottom: '1px solid rgba(224,224,224,1)'
              }
            }}
          >
            <HeaderComponent
              uuid={uuid}
              resetRef={resetRef}
              notReportRef={notReportRef}
              nameRef={nameRef}
              lefts={lefts}
            />

            <TableBody>
              <CommonRowComponent
                headerHeight={headerHeight}
                lefts={lefts}
                suiroExtractList={suiroExtractList}
                users={users}
                setOtherSuiroExtractList={setOtherSuiroExtractList}
                {...handlers}
              />

              {suiroExtractList.map((row) => (
                <DataRowComponent
                  key={row.uuid}
                  row={row}
                  lefts={lefts}
                  users={users}
                  partners={partners}
                  {...handlers}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
};